import { useRef, useEffect, useState, useCallback } from "react";

function _defineProperty(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}

function ownKeys(e, t) {
  var r = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, o);
  }

  return r;
}

function _objectSpread2(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? ownKeys(Object(r), !0).forEach(function (t) {
      _defineProperty(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }

  return e;
}

function _slicedToArray(e, t) {
  return _arrayWithHoles(e) || _iterableToArrayLimit(e, t) || _unsupportedIterableToArray(e, t) || _nonIterableRest();
}

function _arrayWithHoles(e) {
  if (Array.isArray(e)) return e;
}

function _iterableToArrayLimit(e, t) {
  if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
    var r = [],
        o = !0,
        n = !1,
        a = void 0;

    try {
      for (var i, c = e[Symbol.iterator](); !(o = (i = c.next()).done) && (r.push(i.value), !t || r.length !== t); o = !0) {
        ;
      }
    } catch (e) {
      n = !0, a = e;
    } finally {
      try {
        o || null == c.return || c.return();
      } finally {
        if (n) throw a;
      }
    }

    return r;
  }
}

function _unsupportedIterableToArray(e, t) {
  if (e) {
    if ("string" == typeof e) return _arrayLikeToArray(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? _arrayLikeToArray(e, t) : void 0;
  }
}

function _arrayLikeToArray(e, t) {
  (null == t || t > e.length) && (t = e.length);

  for (var r = 0, o = new Array(t); r < t; r++) {
    o[r] = e[r];
  }

  return o;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var commonjsGlobal = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {},
    FUNC_ERROR_TEXT = "Expected a function",
    NAN = NaN,
    symbolTag = "[object Symbol]",
    reTrim = /^\s+|\s+$/g,
    reIsBadHex = /^[-+]0x[0-9a-f]+$/i,
    reIsBinary = /^0b[01]+$/i,
    reIsOctal = /^0o[0-7]+$/i,
    freeParseInt = parseInt,
    freeGlobal = "object" == typeof commonjsGlobal && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal,
    freeSelf = "object" == typeof self && self && self.Object === Object && self,
    root = freeGlobal || freeSelf || Function("return this")(),
    objectProto = Object.prototype,
    objectToString = objectProto.toString,
    nativeMax = Math.max,
    nativeMin = Math.min,
    now = function now() {
  return root.Date.now();
};

function debounce(e, t, r) {
  var o,
      n,
      a,
      i,
      c,
      u,
      l = 0,
      s = !1,
      f = !1,
      d = !0;
  if ("function" != typeof e) throw new TypeError(FUNC_ERROR_TEXT);

  function b(t) {
    var r = o,
        a = n;
    return o = n = void 0, l = t, i = e.apply(a, r);
  }

  function p(e) {
    return l = e, c = setTimeout(m, t), s ? b(e) : i;
  }

  function y(e) {
    var r = e - u;
    return void 0 === u || r >= t || r < 0 || f && e - l >= a;
  }

  function m() {
    var e = now();
    if (y(e)) return g(e);
    c = setTimeout(m, function (e) {
      var r = t - (e - u);
      return f ? nativeMin(r, a - (e - l)) : r;
    }(e));
  }

  function g(e) {
    return c = void 0, d && o ? b(e) : (o = n = void 0, i);
  }

  function v() {
    var e = now(),
        r = y(e);

    if (o = arguments, n = this, u = e, r) {
      if (void 0 === c) return p(u);
      if (f) return c = setTimeout(m, t), b(u);
    }

    return void 0 === c && (c = setTimeout(m, t)), i;
  }

  return t = toNumber(t) || 0, isObject(r) && (s = !!r.leading, a = (f = "maxWait" in r) ? nativeMax(toNumber(r.maxWait) || 0, t) : a, d = "trailing" in r ? !!r.trailing : d), v.cancel = function () {
    void 0 !== c && clearTimeout(c), l = 0, o = u = n = c = void 0;
  }, v.flush = function () {
    return void 0 === c ? i : g(now());
  }, v;
}

function isObject(e) {
  var t = typeof e;
  return !!e && ("object" == t || "function" == t);
}

function isObjectLike(e) {
  return !!e && "object" == typeof e;
}

function isSymbol(e) {
  return "symbol" == typeof e || isObjectLike(e) && objectToString.call(e) == symbolTag;
}

function toNumber(e) {
  if ("number" == typeof e) return e;
  if (isSymbol(e)) return NAN;

  if (isObject(e)) {
    var t = "function" == typeof e.valueOf ? e.valueOf() : e;
    e = isObject(t) ? t + "" : t;
  }

  if ("string" != typeof e) return 0 === e ? e : +e;
  e = e.replace(reTrim, "");
  var r = reIsBinary.test(e);
  return r || reIsOctal.test(e) ? freeParseInt(e.slice(2), r ? 2 : 8) : reIsBadHex.test(e) ? NAN : +e;
}

var lodash_debounce = debounce,
    useLatest = function useLatest(e) {
  var t = useRef(e);
  return useEffect(function () {
    t.current = e;
  }, [e]), t;
},
    loadApiErr = "> 💡use-places-autocomplete: Google Maps Places API library must be loaded. See: https://github.com/wellyshen/use-places-autocomplete#load-the-library",
    usePlacesAutocomplete = function usePlacesAutocomplete() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
      t = e.requestOptions,
      r = e.debounce,
      o = void 0 === r ? 200 : r,
      n = e.googleMaps,
      a = e.callbackName,
      i = useState(!1),
      c = _slicedToArray(i, 2),
      u = c[0],
      l = c[1],
      s = useState(""),
      f = _slicedToArray(s, 2),
      d = f[0],
      b = f[1],
      p = useState({
    loading: !1,
    status: "",
    data: []
  }),
      y = _slicedToArray(p, 2),
      m = y[0],
      g = y[1],
      v = useRef(null),
      j = useLatest(t),
      w = useLatest(n),
      O = useCallback(function () {
    var e,
        t = window.google,
        r = w.current,
        o = (null == r ? void 0 : r.places) || (null == t || null === (e = t.maps) || void 0 === e ? void 0 : e.places);
    o ? (v.current = new o.AutocompleteService(), l(!0)) : console.error(loadApiErr);
  }, []),
      h = useCallback(function () {
    g({
      loading: !1,
      status: "",
      data: []
    });
  }, []),
      _ = useCallback(lodash_debounce(function (e) {
    e ? (g(function (e) {
      return _objectSpread2(_objectSpread2({}, e), {}, {
        loading: !0
      });
    }), v.current.getPlacePredictions(_objectSpread2(_objectSpread2({}, j.current), {}, {
      input: e
    }), function (e, t) {
      g({
        loading: !1,
        status: t,
        data: e || []
      });
    })) : h();
  }, o), [o, h]),
      T = useCallback(function (e) {
    var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
    b(e), t && _(e);
  }, [_]);

  return useEffect(function () {
    var e = window.google;
    return w.current || (null == e ? void 0 : e.maps) || !a ? O() : window[a] = O, function () {
      window[a] && delete window[a];
    };
  }, [a, O]), {
    ready: u,
    value: d,
    suggestions: m,
    setValue: T,
    clearSuggestions: h
  };
},
    geocodeErr = "> 💡use-places-autocomplete: Please provide an address when using getGeocode() with the componentRestrictions.",
    getGeocode = function getGeocode(e) {
  var t = new window.google.maps.Geocoder();
  return new Promise(function (r, o) {
    t.geocode(e, function (t, n) {
      "OK" !== n && o(n), !e.address && e.componentRestrictions && (console.error(geocodeErr), r(t)), r(t);
    });
  });
},
    getLatLng = function getLatLng(e) {
  return new Promise(function (t, r) {
    try {
      var o = e.geometry.location,
          n = o.lat,
          a = o.lng;
      t({
        lat: n(),
        lng: a()
      });
    } catch (e) {
      r(e);
    }
  });
},
    getZipCode = function getZipCode(e, t) {
  return new Promise(function (r, o) {
    try {
      var n = null;
      e.address_components.forEach(function (e) {
        var r = e.long_name,
            o = e.short_name;
        e.types.includes("postal_code") && (n = t ? o : r);
      }), r(n);
    } catch (e) {
      o(e);
    }
  });
};

export default usePlacesAutocomplete;
export { getGeocode, getLatLng, getZipCode };